export var canUseDOM = typeof document !== 'undefined';
export var calculateHeaderOffsetValues = tr => {
  var offsetLeftValues;
  try {
    var trChildren = tr !== null && tr !== void 0 && tr.childNodes ? Array.from(tr.childNodes) : [];
    offsetLeftValues = trChildren.map(_ref => {
      var {
        offsetLeft = 0
      } = _ref;
      return offsetLeft;
    });
  } catch (e) {
    offsetLeftValues = [];
  }
  return offsetLeftValues;
};
export var getWidth = () => {
  var width = 0;
  if (!canUseDOM) return width;
  try {
    width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  } catch (e) {
    width = 0;
  }
  return width;
};